(function () {
    'use strict';
    var controllerId = 'answerQuestions';
    angular.module('app').controller(controllerId, ['$rootScope', "bootstrap.dialog", '$scope', '$uibModalInstance', 'datacontext', 'sectionMenu', "common", "sessione", "$translate", "$interval", answerQuestions]);

    function answerQuestions($rootScope, bDialog, $scope, $uibModalInstance, datacontext, sectionMenu, common, sessione, $translate, $inteval) {
        $scope.sessione = sessione;
        $scope.btnStartDisabled = false;
        $scope.showPartecipazione = false;
        $scope.getRecord = getRecord;
        $scope.item = {};
        $scope.item.code = "";
        $scope.start = start;
        getRecord();
        var currentLanguage = $translate.proposedLanguage() || $translate.use();


        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getRecord() {
            //Record Sessione
            datacontext.session_get($scope.sessione.Id).then(function (sessione) {
                if (sessione != null) {
                    $scope.sessione = sessione;

                    datacontext.studenteSession_getBySessionId($scope.sessione.Id).then(function (studenteSession) {                                                
                        $scope.studenteSession = studenteSession;

                        if ($scope.studenteSession.completed == true)
                            $scope.showPartecipazione = true;                        
                    });
                }
            });
        }

        function start() {
            $scope.btnStartDisabled = true;

            datacontext.studenteSession_start($scope.sessione.Id, $scope.item.code).then(function (data) {                
                if (data == "SES.07") {
                    var title = $translate.instant('AllievoBloccato');
                    var msg = $translate.instant('NotaAllievoBloccato');
                    bDialog.informationDialog(title, msg, $translate.instant('Chiudi')).then(function () {

                    });
                } else if (data == "SES.08") {
                    var title = $translate.instant('AllievoAbilitato');
                    var msg = $translate.instant('NotaAllievoAbilitato');
                    bDialog.informationDialog(title, msg, $translate.instant('Chiudi')).then(function () {

                    });
                } else if (data == "SES.03") {
                    var title = $translate.instant('CodiceErrato');
                    var msg = $translate.instant('NotaCodice');
                    bDialog.informationDialog(title, msg, $translate.instant('Chiudi')).then(function () {

                    });
                } else {
                    $uibModalInstance.close(data.Id);
                }

                $scope.btnStartDisabled = false;
            });
        }

    }
})();